import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { AUTHORIZE_BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class DealerGroupingClient {
  static baseUrl = AUTHORIZE_BASE_URL;

  static getDealerGroup(user, salesCode, page) {
    const resourcePath =
      user.market.toUpperCase() === "CAN"
        ? `dealer/${user.dealerGroupId}`
        : user.generateResourcePath();

    let url = `${this.baseUrl}/${resourcePath}/dealer-group`;
    if (salesCode) {
      url += "?salesCode=" + salesCode;
    }

    if (page) {
      url += salesCode ? "&page=" : "?page=" + page;
    }

    return axios
      .get(url, getHeaders())
      .then((response) => {
        return response.data.result.dealerGroupings;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        } else {
          user.history.push("/error");
        }

        return Promise.reject(error);
      });
  }

  static getDealer(user, salesCode) {
    const url = `${this.baseUrl}/dealer?salesCode=${salesCode}`;

    return axios
      .get(url, getHeaders())
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getDealerInfoCanada(user) {
    const url = `${this.baseUrl}/can/dealer-info`;

    return axios
      .get(url, getHeaders())
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        } else {
          user.history.push("/error");
        }
        return Promise.reject(error);
      });
  }
}
